import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Star } from "lucide-react";
import { track } from "@/lib/analytics";
import { getLinks, telHref } from "@/lib/links";
import TikTokIcon from "./TikTokIcon";
import Logo3D from "./Logo3D";

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Footer({ settings }) {
  const social = settings?.social || {};
  const links = getLinks(settings);
  const circle = "w-11 h-11 rounded-full border border-[#333] flex items-center justify-center text-white hover:bg-[#FFC20E] hover:text-[#0C0C0C] transition-colors";
  return (
    <footer className="relative bg-[#0C0C0C] border-t-4 border-[#FFC20E] pt-14 pb-24 lg:pb-14">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div data-testid="footer-logo" className="w-52 max-w-full">
              <Logo3D className="w-full" depth={9} />
            </div>
            <p className="font-display font-black uppercase text-2xl text-[#FFC20E] mt-4" data-testid="footer-payoff">MORDI LA VOGLIA</p>
          </div>

          <div className="grid grid-cols-2 gap-2">
            {[
              { label: "Menu", id: "menu" },
              { label: "Il Morso", id: "morso" },
              { label: "UNGRIP Club", id: "club" },
              { label: "Dove siamo", id: "location" },
            ].map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                className="text-left font-display font-bold uppercase text-white/80 hover:text-[#FFC20E] transition-colors py-1"
                data-testid={`footer-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
            <Link to="/privacy" className="font-display font-bold uppercase text-white/80 hover:text-[#FFC20E] transition-colors py-1" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/cookie" className="font-display font-bold uppercase text-white/80 hover:text-[#FFC20E] transition-colors py-1" data-testid="footer-link-cookie">Cookie</Link>
            <a href={`mailto:${settings?.contact?.email || "ciao@ungrip.it"}`} className="font-display font-bold uppercase text-white/80 hover:text-[#FFC20E] transition-colors py-1" data-testid="footer-link-contatti">Contatti</a>
          </div>

          <div>
            <span className="font-display font-bold uppercase tracking-widest text-sm text-white/50">Social</span>
            <div className="flex gap-3 mt-3" data-testid="footer-social-links">
              {links.instagram && (
                <a href={links.instagram} target="_blank" rel="noopener noreferrer" onClick={() => track("instagram_click", { from: "footer" })}
                  className={circle} aria-label="Instagram" data-testid="footer-instagram">
                  <Instagram size={20} />
                </a>
              )}
              {links.tiktok && (
                <a href={links.tiktok} target="_blank" rel="noopener noreferrer" onClick={() => track("tiktok_click", { from: "footer" })}
                  className={circle} aria-label="TikTok" data-testid="footer-tiktok">
                  <TikTokIcon size={20} />
                </a>
              )}
              {links.phone && (
                <a href={telHref(links.phone)} onClick={() => track("phone_click", { from: "footer" })}
                  className={circle} aria-label="Chiamaci" data-testid="footer-phone">
                  <Phone size={20} />
                </a>
              )}
              {links.review && (
                <a href={links.review} target="_blank" rel="noopener noreferrer" onClick={() => track("google_review_click", { from: "footer" })}
                  className={circle} aria-label="Recensisci su Google" data-testid="footer-google-review">
                  <Star size={20} />
                </a>
              )}
              {social.facebook && (
                <a href={social.facebook} target="_blank" rel="noopener noreferrer" onClick={() => track("social_click", { network: "facebook" })}
                  className="w-11 h-11 rounded-full border border-[#333] flex items-center justify-center text-white hover:bg-[#FFC20E] hover:text-[#0C0C0C] transition-colors" aria-label="Facebook">
                  <Facebook size={20} />
                </a>
              )}
            </div>
            {links.phone && (
              <a href={telHref(links.phone)} onClick={() => track("phone_click", { from: "footer_number" })}
                className="inline-block mt-4 font-display font-bold uppercase text-white/80 hover:text-[#FFC20E] transition-colors py-2.5" data-testid="footer-phone-number">
                {links.phone}
              </a>
            )}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#1c1c1c] flex flex-col sm:flex-row justify-between gap-2 text-white/40 text-sm">
          <span>© {new Date().getFullYear()} UNGRIP — Foggia. Tutti i morsi riservati.</span>
          <Link to="/admin/login" className="hover:text-[#FFC20E] transition-colors">Area riservata</Link>
        </div>
      </div>
    </footer>
  );
}
